/* eslint-disable no-useless-escape */
import axios from 'axios';
import config from '../../../config'

const axiosInstance = axios.create({
    baseURL: config.onboardingWebApiUrl,
    withCredentials: true,
    headers: { Pragma: 'no-cache' }
});

export const dataLoader = {
  name: 'data-loader',
  data: function () {
    return {
      //onboardingWebApiUrl: process.env.VUE_APP_ONBOARDING_WEBAPI_URL,
      countryPhoneNumberFormats: {
        "643" : {
          mask: "+7 (###) ### ## ##",
          placeholder: "+ 7 ( ___ ) ___ __ __",
          phoneRegex: /^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{10}$/
        },
        "112" : {
          mask: "+375 (###) ## ## ##",
          placeholder: "+ 375 ( ___ ) __ __ __",
          phoneRegex: /^((\+375)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{8}$/
        }
      },
      defaultCountryCode: "643"
    };
  },
  methods: {  
    getAxiosPromise: async function(url, params, callback) {
      const request = axiosInstance.post(url, params, { withCredentials: true })
              .then((response) => { callback(response.data); })
              .catch((error) => { console.log(error); });

      const response = await request;

      return response
    },
    userRegistration: async function (params, callback) {
      const url = '/Registration';

      await this.getAxiosPromise(url, params, callback);
    },
    changePassword: async function (params, callback) {
      const url = '/Password';

      await this.getAxiosPromise(url, params, callback);
    },
    changeLoginAndPassword: async function (params, callback) {
      const url = '/Registration/ChangeLoginAndPassword';

      await this.getAxiosPromise(url, params, callback);
    },
    checkEmailConfirmed: async function (callback) {
      const url = '/Registration/CheckEmailConfirmed';

      await this.getAxiosPromise(url, null, callback);
    },
    checkUserCredentials: async function (params, callback) {
      const url = '/Registration/CheckUserCredentials';

      await this.getAxiosPromise(url, params, callback);
    },
    login: async function (params, callback) {
      const url = '/Login';

      await this.getAxiosPromise(url, params, callback);
    },
    getProfitUrl: async function (callback) {
      const url = '/Registration/GetProfitUrl';

      await this.getAxiosPromise(url, null, callback);
    },
    addUserStepLog: async function (params, callback) {
      const url = '/Registration/AddUserStepLog';

      await this.getAxiosPromise(url, params, callback);
    },
    getPhoneNumberMask(countryCode){
      if (countryCode){
        const formatter = this.countryPhoneNumberFormats[countryCode];

        if (formatter){
          return formatter.mask;
        }
      }

      return this.countryPhoneNumberFormats[this.defaultCountryCode].mask;
    },
    getPhoneNumberPlaceholder(countryCode){
      if (countryCode){
        const formatter = this.countryPhoneNumberFormats[countryCode];

        if (formatter){
          return formatter.placeholder;
        }
      }

      return this.countryPhoneNumberFormats[this.defaultCountryCode].placeholder;
    },
    getPhoneNumberRegex(countryCode){
      if (countryCode){
        const formatter = this.countryPhoneNumberFormats[countryCode];

        if (formatter){
          return formatter.phoneRegex;
        }
      }

      return this.countryPhoneNumberFormats[this.defaultCountryCode].phoneRegex;
    }
  }
};